import { render } from "./DefaultSkeleton.vue?vue&type=template&id=e08f7a10&scoped=true&ts=true"
import script from "./DefaultSkeleton.vue?vue&type=script&lang=ts"
export * from "./DefaultSkeleton.vue?vue&type=script&lang=ts"

import "./DefaultSkeleton.vue?vue&type=style&index=0&id=e08f7a10&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08f7a10"]])

export default __exports__